var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intolerance",class:{ 'is-active': _vm.isActive },on:{"click":_vm.select}},[_c('div',{staticClass:"intolerance__label"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }